import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ImageFrame = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: theme.spacing(12.5),
  padding: theme.spacing(1),
  border: `1px solid ${theme.palette.grey[400]}`,
  borderRadius: theme.shape.borderRadius,
}));

export const ImageFrameImage = styled('img')({
  height: '100%',
  width: '100%',
  objectFit: 'scale-down',
});
